/**
 * UTC -> user-timezone display helpers.
 * Storage and transport always use UTC ISO 8601 (`...Z`); only the UI layer
 * converts for display.
 */

const DATE_FMT = { day: '2-digit', month: 'short', year: 'numeric' };
const TIME_FMT = { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false };

export const TIMEZONES = [
  ['UTC',                 'UTC — Coordinated Universal Time'],
  ['Europe/London',       'Europe/London (GMT/BST)'],
  ['Europe/Paris',        'Europe/Paris (CET/CEST)'],
  ['Europe/Berlin',       'Europe/Berlin (CET/CEST)'],
  ['Europe/Kyiv',         'Europe/Kyiv (EET/EEST)'],
  ['Europe/Moscow',       'Europe/Moscow (MSK)'],
  ['Europe/Istanbul',     'Europe/Istanbul (TRT)'],
  ['Europe/Athens',       'Europe/Athens (EET/EEST)'],
  ['Europe/Bucharest',    'Europe/Bucharest (EET/EEST)'],
  ['Europe/Warsaw',       'Europe/Warsaw (CET/CEST)'],
  ['Europe/Helsinki',     'Europe/Helsinki (EET/EEST)'],
  ['Asia/Tbilisi',        'Asia/Tbilisi (GET)'],
  ['Asia/Baku',           'Asia/Baku (AZT)'],
  ['Asia/Dubai',          'Asia/Dubai (GST)'],
  ['Asia/Kolkata',        'Asia/Kolkata (IST)'],
  ['Asia/Shanghai',       'Asia/Shanghai (CST)'],
  ['Asia/Tokyo',          'Asia/Tokyo (JST)'],
  ['America/New_York',    'America/New_York (EST/EDT)'],
  ['America/Chicago',     'America/Chicago (CST/CDT)'],
  ['America/Denver',      'America/Denver (MST/MDT)'],
  ['America/Los_Angeles', 'America/Los_Angeles (PST/PDT)'],
];

/**
 * "06 May 2026, 23:59:27 EEST" — date, time, short timezone abbreviation.
 */
export function formatUtcInTimezone(isoUtc, timeZone = 'UTC') {
  if (!isoUtc) return '';
  const date = new Date(isoUtc);
  if (Number.isNaN(date.getTime())) return '';

  const datePart = new Intl.DateTimeFormat('en-GB', { ...DATE_FMT, timeZone }).format(date);
  const timePart = new Intl.DateTimeFormat('en-GB', { ...TIME_FMT, timeZone }).format(date);
  const tzAbbr =
    new Intl.DateTimeFormat('en-GB', { timeZone, timeZoneName: 'short' })
      .formatToParts(date)
      .find((p) => p.type === 'timeZoneName')?.value || 'UTC';

  return `${datePart}, ${timePart} ${tzAbbr}`;
}
